import React from "react";
import { NextSeo } from "next-seo";
import ShopCard from "../components/shop/ShopCard";
import RedGem from "../components/shop/svgs/RedGem";
import GreenGem from "../components/shop/svgs/GreenGem";
import BlueGem from "../components/shop/svgs/BlueGem";
import useSubscription from "../hooks/useSubscription";

const ItemShopPage = () => {
  const items = [
    {
      category: "Voice Training Packs",
      items: [
        {
          name: "Basic Pack",
          price: 5,
          description: "Basic voice training pack",
          amount: 3,
          gem: BlueGem,
        },
        {
          name: "Advanced Pack",
          price: 9,
          description: "Intermediate voice training pack",
          amount: 7,
          gem: GreenGem,
        },
        {
          name: "Epic Pack",
          price: 15,
          description: "Advanced voice training pack",
          amount: 15,
          gem: RedGem,
        },
      ],
    },
  ];

  const { hasCreatorPlan, hasPowerPlan } = useSubscription();
  const hasDiscount = hasCreatorPlan() || hasPowerPlan();

  return (
    <div className="tw-w-full tw-bg-white tw-text-jam-ink">
      <NextSeo
        title="Item Shop | Jammable"
        description="Buy voice training packs and credits for Jammable — the #1 AI cover platform. Train custom AI voices and create unlimited AI covers."
        canonical="https://www.jammable.com/shop"
        openGraph={{
          title: "Item Shop | Jammable",
          description:
            "Buy voice training packs and credits for Jammable — the #1 AI cover platform.",
          url: "https://www.jammable.com/shop",
          type: "website",
          siteName: "Jammable",
        }}
      />
      <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-[1100px] tw-flex-col tw-gap-8 tw-px-4 tw-pb-24 tw-pt-4 md:tw-px-8 md:tw-pb-16 md:tw-pt-6">
        <section className="tw-flex tw-flex-col tw-items-start tw-gap-4 md:tw-items-center md:tw-text-center">
          <span
            className={`tw-rounded-full tw-px-3 tw-py-1.5 tw-text-xs tw-font-extrabold md:tw-px-3.5 md:tw-text-[13px] ${
              hasDiscount ? "tw-bg-jam-lime" : "tw-bg-jam-lav"
            }`}
          >
            {hasDiscount
              ? "Your 50% creator plan discount has been applied"
              : "All shop items are 50% off on the creator plan"}
          </span>
          <h1 className="jam-display tw-m-0 tw-text-[40px] tw-font-extrabold tw-leading-none tw-tracking-[-0.045em] md:tw-text-[68px]">
            Item Shop
          </h1>
          <p className="tw-m-0 tw-max-w-[520px] tw-text-[15px] tw-font-semibold tw-text-jam-muted md:tw-text-lg">
            One-time packs for a better Jammable experience. No subscription
            needed.
          </p>
        </section>
        {items.map((item) => {
          return (
            <section
              key={item.category}
              className="tw-flex tw-flex-col tw-gap-5 tw-rounded-[32px] tw-bg-jam-lav tw-p-5 md:tw-rounded-[44px] md:tw-p-10"
            >
              <div className="tw-flex tw-flex-col tw-gap-1 md:tw-items-center md:tw-text-center">
                <h2 className="jam-display tw-m-0 tw-text-[28px] tw-font-extrabold tw-tracking-[-0.03em] md:tw-text-[34px]">
                  {item.category}
                </h2>
                <p className="tw-m-0 tw-text-sm tw-font-semibold tw-text-jam-muted">
                  Each pass trains one custom voice.
                </p>
              </div>

              <div className="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-3 md:tw-gap-4">
                {item.items.map((item) => {
                  return (
                    <ShopCard
                      key={item.name}
                      item={item}
                      hasDiscount={hasDiscount}
                    />
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default ItemShopPage;
